// Module
var code = "<template> <raago-container stretch=\"page\"> <raago-spacing vertical=\"m\"> <div innerHtml.bind=\"cmsFragment.html | sanitizeHTML\"></div> </raago-spacing> </raago-container> </template>";
// Exports
export default code;